/**
 * Filter dropdown toggling
 */

document.querySelectorAll('.filter')?.forEach((filter) => {
	// cache dom nodes
	const trigger = filter.querySelector('.filter__trigger');
	const menu = trigger.nextElementSibling.firstElementChild;
	const clear = filter.querySelector('.filter__all');
	// toggle menu visibility
	const toggleMenu = () => {
		const isExpanding = trigger.getAttribute('aria-expanded') !== 'true';
		trigger.setAttribute('aria-expanded', isExpanding);
		menu.setAttribute('aria-hidden', !isExpanding);
	};
	// on click of the main toggler
	trigger.addEventListener('click', (e) => {
		e.preventDefault();
		toggleMenu();
	});
	// on click of inner boxes
	filter.querySelectorAll('.filter__box')?.forEach((box) => {
		// for normal boxes we'll collapse the filter
		if (!box.classList.contains('filter__box--trigger')) {
			box.addEventListener('change', toggleMenu);
			// eslint-disable-next-line prettier/prettier
		// for expander boxes we'll expand what's beneath them (visible at mobile)gs
		} else {
			box.addEventListener('change', () => {
				box.setAttribute('aria-expanded', box.checked);
			});
		}
	});
	// on click of "clear all" button
	clear.addEventListener('click', toggleMenu);
	// trigger.click(); /* DEBUG */
});
